import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSigninSignUpModalPrivatePolicyClick } from "@faire/web-api--source/events/signin/click/signUpModalPrivatePolicy";
import { trackSignupSignUpModalTermsClick } from "@faire/web-api--source/events/signup/click/signUpModalTerms";
import privacyPath from "@faire/web-api--source/routes/privacy";
import termsOfService from "@faire/web-api--source/routes/tos";
import React from "react";
import styled from "styled-components";
export var TermsAndPrivacyPolicyDisclaimer = function() {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "7MWdTe",
        defaultMessage: [
            {
                type: 0,
                value: "By proceeding, you agree to our "
            },
            {
                type: 8,
                value: "TosLinkFormatting",
                children: [
                    {
                        type: 0,
                        value: "Terms"
                    }
                ]
            },
            {
                type: 0,
                value: " and "
            },
            {
                type: 8,
                value: "PrivacyLinkFormatting",
                children: [
                    {
                        type: 0,
                        value: "Privacy Policy"
                    }
                ]
            },
            {
                type: 0,
                value: "."
            }
        ],
        values: {
            TosLinkFormatting: TosLinkFormatting,
            PrivacyLinkFormatting: PrivacyLinkFormatting
        }
    });
};
var TosLinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(SubduedEmbeddedLink, {
        linkTo: termsOfService(),
        onClick: trackSignupSignUpModalTermsClick,
        children: chunks
    });
};
var PrivacyLinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(SubduedEmbeddedLink, {
        linkTo: privacyPath(),
        onClick: trackSigninSignUpModalPrivatePolicyClick,
        children: chunks
    });
};
var SubduedEmbeddedLink = styled(Button).attrs({
    variant: "tertiary",
    target: "_blank"
}).withConfig({
    componentId: "sc-cce61879-0"
})([
    "color:inherit;text-decoration-color:inherit;font-size:12px;"
]);
